import { render, staticRenderFns } from "./BatchOperationReview.vue?vue&type=template&id=01e8964c&scoped=true&"
import script from "./BatchOperationReview.vue?vue&type=script&lang=js&"
export * from "./BatchOperationReview.vue?vue&type=script&lang=js&"
import style0 from "./BatchOperationReview.vue?vue&type=style&index=0&id=01e8964c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e8964c",
  null
  
)

export default component.exports